import React from 'react';
import { ListSection } from '../../../shared/ListSection';
import { CommuterNavigationListItem } from './CommuterNavigationListItem';
import CommuteresImage from './images/businesses.svg';
import CommutersImage from './images/commuters.svg';
import { STYLES } from '../../../../style'

const data = [
  {
    title: 'Consumer benefits',
    image: CommutersImage,
    url: '/commuters',
    color: STYLES.PAGE_COMMUTERS_BANNER_COLOR,
  },
  {
    title: 'Business benefits',
    image: CommuteresImage,
    url: '/businesses',
    color: STYLES.PAGE_BUSINESSES_BANNER_COLOR,
  },
];

const CommuterNavigation = () => (
  <ListSection
    component={CommuterNavigationListItem}
    data={data}
  />
);

export { CommuterNavigation };